import {defineStore} from "pinia";

export const useProjectExpensesStore = defineStore({
    id: 'projectExpenses',
    state: () => ({
        expenses: [],
    }),
    getters: {
        filterExpenses: (state) => {
            return (name) =>
                state.expenses.filter((category) => category.name === name);
        },
    },
    actions: {
        async fetchExpenses(projectId) {
            // let payments  = await this.$inertia.get(`/projectPaymenst/${projectId}`);
            let expenses = await fetch(`/projectExpenses/${projectId}`).then((res) => res.json());
            this.expenses = expenses;
            console.log(expenses);


        }
    },
});
